(function (angular) {
	'use strict';

	var ipoSharePriceChartObject = {
		template: '<div class="position-relative" style="height:250px"><shared-highchart loader="true" chart-options="ipoSharePrice.chartOptions"></shared-highchart></div>',
		controller: [
			'$filter',
			'Big',
			'Highcharts',
			'urlFactory',
			IpoSharePriceChartFunction
		],
		controllerAs: 'ipoSharePrice'
	};

	angular
		.module('ipoSharePriceChartModule')
		.component('ipoSharePriceChart', ipoSharePriceChartObject);
	
	function IpoSharePriceChartFunction(
		$filter,
		Big,
		Highcharts,
		urlFactory
	) {	
		var ipoSharePrice = this;

		ipoSharePrice.$onInit = function() {
			urlFactory.apiGetPromise('/api/offerings/fundrise-ipo/ipo-share-price-history')
				.then(function(response) {
					var reitPriceSeries = response.data.map(function(reitPrice) {
						return [
							parseInt(reitPrice.dateTime), 
							parseFloat(new Big(reitPrice.price)) 
						];
					});

					initChart(reitPriceSeries);
				});
		};
		
		function initChart(reitPriceSeries) {
			ipoSharePrice.chartOptions = {
				chart: {
					type: "area"
				},
				xAxis: {
					type: "datetime",
					tickInterval: 60 * 24 * 3600 * 1000
				},
				yAxis: {
					labels: {
						formatter: function () {
							return $filter('currency')(this.value, '$', 2);
						}
					},
					min: 4.50
				},
				tooltip: {
					enabled: true,
					useHTML: true,
					formatter: function() {
						return '<div class="text-align-center"><strong class="delta">' + $filter('currency')(this.y, '$', 2) + '</strong><br>' + 
						Highcharts.dateFormat(' %B %e, %Y', new Date(this.x)) + "</div>";
					}
				},
				plotOptions: {
					area: {
						stacking: "normal",
						lineWidth: 2,
						marker: {
							symbol: "circle",
							radius: 4,
							enabled: true
						},
						fillOpacity: 0.25
					},
				},
				series: [{
					name: 'iPO Share Price',
					data: reitPriceSeries
				}]
			};
		}
	}
})(window.angular);